<script setup></script>

<template>
    <div class="layout-footer">
        SAKAI by
        <a class="text-primary font-bold hover:underline" href="https://primevue.org" rel="noopener noreferrer" target="_blank">PrimeVue</a>
    </div>
</template>
